(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
const footerQuery=window.matchMedia('(max-width:700px)');
function syncFooterAccordions(){document.querySelectorAll('.footer__accordion').forEach(el=>{el.open=!footerQuery.matches;});}
syncFooterAccordions();footerQuery.addEventListener('change',syncFooterAccordions);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-premium-details"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const link = event.target.closest('[data-gsp-kit-link]');
  if (!link) return;
  const toggle = document.querySelector('#ProductForm [data-kit-details-toggle]');
  if (toggle && toggle.getAttribute('aria-expanded') !== 'true') toggle.click();
});
(() => {
  let source = null;
  let observer = null;
  let container = null;
  let presenceObserver = null;
  function syncGiftContext() {
    const form = document.querySelector('#ProductForm');
    if (form !== container) {
      if (presenceObserver) presenceObserver.disconnect();
      container = form;
      if (container) {
        presenceObserver = new MutationObserver(changes => {
          const giftChanged = changes.some(change => [...change.addedNodes, ...change.removedNodes].some(node =>
            node.nodeType === 1 && (node.matches('[data-gift-offer]') || node.querySelector('[data-gift-offer]'))
          ));
          if (giftChanged) syncGiftContext();
        });
        presenceObserver.observe(container, {childList:true, subtree:true});
      }
    }
    const banner = document.querySelector('#ProductForm [data-gift-offer]');
    if (banner !== source) {
      if (observer) observer.disconnect();
      source = banner;
      if (source) {
        observer = new MutationObserver(syncGiftContext);
        observer.observe(source, {attributes:true, attributeFilter:['hidden','style','data-gift-valid-until']});
      }
    }
    const expiry = banner ? Number(banner.dataset.giftValidUntil) : NaN;
    const active = Boolean(banner && !banner.hidden && getComputedStyle(banner).display !== 'none' && /GroomBox/i.test(banner.textContent) && Number.isFinite(expiry) && expiry * 1000 > Date.now());
    document.querySelectorAll('[data-gsp-gift-context]').forEach(link => {link.hidden = !active;});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncGiftContext, {once:true});
  else syncGiftContext();
  document.addEventListener('shopify:section:load', syncGiftContext);
  document.addEventListener('visibilitychange', syncGiftContext);
  window.addEventListener('pageshow', syncGiftContext);
})();

  } catch(e) { console.error(e); }
})();
})();
